<script setup lang="ts">
export type TooltipVariant = "white" | "black";
export type TooltipPosition = "left" | "top" | "right" | "bottom";
export type TooltipSize = "small" | "medium" | "large";

interface Props {
  variant: TooltipVariant;
  position: TooltipPosition;
  size?: TooltipSize;
}

withDefaults(defineProps<Props>(), {
  size: "medium",
});
</script>

<template>
  <div
    class="arrow absolute rotate-45 border rounded-sm"
    :class="{
      'w-2 h-2': size === 'small',
      'w-3 h-3': size === 'medium',
      'w-4 h-4': size === 'large',
      '-right-[0.25rem] top-0 bottom-0 my-auto':
        position === 'left' && size === 'small',
      '-right-[0.375rem] top-0 bottom-0 my-auto':
        position === 'left' && size === 'medium',
      '-right-[0.5rem] top-0 bottom-0 my-auto':
        position === 'left' && size === 'large',
      '-left-[0.25rem] top-0 bottom-0 my-auto':
        position === 'right' && size === 'small',
      '-left-[0.375rem] top-0 bottom-0 my-auto':
        position === 'right' && size === 'medium',
      '-left-[0.5rem] top-0 bottom-0 my-auto':
        position === 'right' && size === 'large',
      '-bottom-[0.25rem] left-0 right-0 mx-auto':
        position === 'top' && size === 'small',
      '-bottom-[0.375rem] left-0 right-0 mx-auto':
        position === 'top' && size === 'medium',
      '-bottom-[0.5rem] left-0 right-0 mx-auto':
        position === 'top' && size === 'large',
      '-top-[0.25rem] left-0 right-0 mx-auto':
        position === 'bottom' && size === 'small',
      '-top-[0.375rem] left-0 right-0 mx-auto':
        position === 'bottom' && size === 'medium',
      '-top-[0.5rem] left-0 right-0 mx-auto':
        position === 'bottom' && size === 'large',
      'bg-white border-neutral300': variant === 'white',
      'bg-black  border-transparent': variant === 'black',
    }"
  />
  <div
    class="arrow-fixer absolute"
    :class="{
      'right-0 top-0 bottom-0 my-auto w-1.5 h-3':
        position === 'left' && size === 'small',
      'right-0 top-0 bottom-0 my-auto w-2 h-4':
        position === 'left' && size === 'medium',
      'right-0 top-0 bottom-0 my-auto w-2.5 h-5':
        position === 'left' && size === 'large',
      'left-0 top-0 bottom-0 my-auto w-1.5 h-3':
        position === 'right' && size === 'small',
      'left-0 top-0 bottom-0 my-auto w-2 h-4':
        position === 'right' && size === 'medium',
      'left-0 top-0 bottom-0 my-auto w-2.5 h-5':
        position === 'right' && size === 'large',
      'bottom-0 left-0 right-0 mx-auto w-3 h-1.5':
        position === 'top' && size === 'small',
      'bottom-0 left-0 right-0 mx-auto w-4 h-2':
        position === 'top' && size === 'medium',
      'bottom-0 left-0 right-0 mx-auto w-5 h-2.5':
        position === 'top' && size === 'large',
      'top-0 left-0 right-0 mx-auto w-3 h-1.5':
        position === 'bottom' && size === 'small',
      'top-0 left-0 right-0 mx-auto w-4 h-2':
        position === 'bottom' && size === 'medium',
      'top-0 left-0 right-0 mx-auto w-5 h-2.5':
        position === 'bottom' && size === 'large',
      'bg-white': variant === 'white',
      'bg-black': variant === 'black',
    }"
  />
</template>
